import clsx from 'clsx';
import MuiLink from '@material-ui/core/Link';
import NextLink from 'next/link';
import React from 'react';
import { useRouter } from 'next/router';

const NextComposed = React.forwardRef(function NextComposed(props, ref) {
  const { as, href, children, ...others } = props;

  return (
    <NextLink ref={ref} href={href} as={as} {...others}>
      {children}
    </NextLink>
  );
});

// A styled version of the Next.js Link component:
// https://nextjs.org/docs/#with-link
function Link(props) {
  const {
    href,
    activeClassName = 'active',
    className: classNameProps,
    innerRef,
    naked,
    ...other
  } = props;

  const router = useRouter();
  const pathname = typeof href === 'string' ? href : href.pathname;
  const className = clsx(classNameProps, {
    [activeClassName]: router.pathname === pathname && activeClassName,
  });

  if (naked) {
    return (
      <NextComposed
        className={className}
        ref={innerRef}
        href={href}
        {...other}
      />
    );
  }

  return (
    <MuiLink
      component={NextComposed}
      className={className}
      ref={innerRef}
      href={href}
      {...other}
    />
  );
}

export default React.forwardRef(function LinkEx(props, ref) {
  return <Link {...props} innerRef={ref} />;
});
